<app-tab>
  <dx-data-grid
    id="driversGridContainer"
    [dataSource]="ds"
    [libGridDefault]="{stateStorageKey: 'app-tanks-grid'}"
    [columnHidingEnabled]="false"
    (onEditingStart)="onEdit($event)"
    (onInitNewRow)="onEdit($event)"
    [libGridTitle]="{text: 'Les Citernes'}">
    <dxi-column
      caption="ID"
      dataField="id"
      sortOrder="desc"
      width="6%"
      [allowEditing]="false"
      [formItem]="{visible: false}"
      dataType="number">
    </dxi-column>

    <dxi-column
      caption="Nom"
      dataField="name"
      dataType="string">
      <dxi-validation-rule type="required"></dxi-validation-rule>
      <dxi-validation-rule type="stringLength" [min]="3" [max]="100"></dxi-validation-rule>
    </dxi-column>

    <dxi-column
      caption="Capacité"
      dataField="capacity"
      dataType="number">
    </dxi-column>

    <dxi-column
      caption="Niveau (L)"
      format="#0.##"
      dataField="sensor_level"
      [allowEditing]="false"
      [formItem]="{visible: false}"
      dataType="number">
      <!--<div *dxTemplate="let data of 'levelTemplate'">
        <span class="w-full flex items-center justify-end">
          <div class="px-2">{{data.text}}</div>
          <a href="#" title="Afficher l'historique" (click)="showLevelHistory($event, data.data)">
            <ic-icon [icon]="historyIcon" width="18px" height="18px" [inline]="true"></ic-icon>
          </a>
        </span>
      </div>-->
    </dxi-column>

    <dxi-column
      caption="Niveau (%)"
      dataField="level_percent"
      [allowEditing]="false"
      [formItem]="{visible: false}"
      format="percent"
      dataType="number">
    </dxi-column>

    <dxi-column
      caption="Position"
      cellTemplate="cellTemplate"
      [allowEditing]="false"
      [allowFiltering]="false"
      [allowSorting]="false"
      [allowSearch]="false"
      [formItem]="{visible: false}">
      <div *dxTemplate="let data of 'cellTemplate'">
        <a target="_blank"
           href="https://www.google.com/maps/search/?api=1&query={{data.row.data.sensor_lat}},{{data.row.data.sensor_lng}}">{{data.row.data.sensor_lat}}
          ,{{data.row.data.sensor_lng}}</a>
      </div>
    </dxi-column>

    <dxi-column
      caption="Dernière mise à jour"
      [allowEditing]="false"
      [formItem]="{visible: false}"
      dataField="template_updated_at"
      format="shortDateShortTime"
      dataType="date">
    </dxi-column>

    <dxi-column
      caption="IMEI"
      dataField="template_source_id"
      dataType="string">
      <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>

    <dxi-column
      caption="Domaine"
      [allowEditing]="false"
      [formItem]="{visible: false}"
      dataField="domain_name">
    </dxi-column>

    <dxi-column
      caption="BU"
      [allowEditing]="false"
      [formItem]="{visible: false}"
      dataField="business_unit_name">
    </dxi-column>

    <dxi-column
      caption="Date création"
      [allowEditing]="false"
      [visible]="false"
      [formItem]="{visible: false}"
      dataField="created_at"
      format="shortDateShortTime"
      dataType="date">
    </dxi-column>

    <dxi-column
      caption="Date modification"
      [allowEditing]="false"
      [visible]="false"
      [formItem]="{visible: false}"
      dataField="updated_at"
      format="shortDateShortTime"
      dataType="date">
    </dxi-column>

    <dxi-column
      caption="Domaine"
      dataField="domain_id"
      editCellTemplate="domainChooser"
      [visible]="false"
      [showInColumnChooser]="false">
      <div *dxTemplate="let cellInfo of 'domainChooser';">
        <app-user-domains-chooser (valueChange)="cellInfo.setValue($event)"
                                  [id]="cellInfo.value"></app-user-domains-chooser>
      </div>
      <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>

    <dxi-column
      caption="Points"
      dataField="level_calibration_settings.calibration"
      editCellTemplate="levelCalibration"
      [visible]="false"
      [showInColumnChooser]="false">
      <div *dxTemplate="let cellInfo of 'levelCalibration';">

        <lib-level-calibration (valueChange)="cellInfo.setValue($event)"
                               [value]="cellInfo.value"></lib-level-calibration>
      </div>
    </dxi-column>


    <dxi-column
      caption="Longeur Jauge (mm)"
      dataType="number"
      dataField="level_calibration_settings.custom.gauge_length"
      [visible]="false"
      [showInColumnChooser]="false">
      <dxo-form-item editorType="dxNumberBox"
                     [editorOptions]="{format: '#0 mm'}"></dxo-form-item>
      <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>

    <dxi-column
      caption="Min ADC (V)"
      dataField="level_calibration_settings.custom.min_adc"
      dataType="number"
      [visible]="false"
      [showInColumnChooser]="false">
      <dxo-form-item editorType="dxNumberBox"
                     [editorOptions]="{format: '#0.### V'}"></dxo-form-item>
      <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>

    <dxi-column
      caption="Max ADC (V)"
      dataType="number"
      dataField="level_calibration_settings.custom.max_adc"
      [visible]="false"
      [showInColumnChooser]="false">
      <dxo-form-item editorType="dxNumberBox"
                     [editorOptions]="{format: '#0.### V'}"></dxo-form-item>
      <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>

    <dxi-column
      caption="Décalage"
      dataType="number"
      dataField="level_calibration_settings.custom.offset"
      [visible]="false"
      [showInColumnChooser]="false">
      <dxo-form-item editorType="dxNumberBox"
                     [editorOptions]="{format: '#0 L'}"></dxo-form-item>
      <dxi-validation-rule type="required"></dxi-validation-rule>
    </dxi-column>

    <dxi-column
      caption="Valeur de Test"
      dataType="number"
      dataField="test_value"
      [visible]="false"
      [showInColumnChooser]="false">
      <dxo-form-item editorType="dxNumberBox"
                     [editorOptions]="{format: '#0.### V', buttons:[{name: 'test', options: testButton}]}"></dxo-form-item>
    </dxi-column>

    <dxi-column type="buttons" [width]="110">
      <dxi-button
        hint="Remplissage"
        icon="ld-fuel-station"
        [onClick]="showLevelChanges"></dxi-button>
      <dxi-button
        hint="Hitorique"
        icon="ld-history"
        [onClick]="showLevelHistory"></dxi-button>
      <dxi-button name="edit"></dxi-button>
      <dxi-button name="delete"></dxi-button>
    </dxi-column>

    <dxo-editing
      mode="popup"
      [(changes)]="changes"
      [allowDeleting]="canDelete"
      [allowAdding]="canAdd"
      [allowUpdating]="canEdit">

      <dxo-popup [showTitle]="false" width="40%" [height]="650"></dxo-popup>


      <dxo-form [colCount]="1" [onContentReady]="formContentReady">
        <dxi-item itemType="group" colSpan="2" colCount="2" caption="Général">
          <dxi-item dataField="name">
            <dxi-validation-rule type="required"></dxi-validation-rule>
          </dxi-item>
          <dxi-item dataField="capacity"></dxi-item>
          <dxi-item dataField="domain_id"></dxi-item>
        </dxi-item>

        <dxi-item *ngIf="canEditSensors" itemType="group" colSpan="2" colCount="2" caption="Capteurs">
          <dxi-item dataField="template_source_id"></dxi-item>
          <dxi-item dataField="level_calibration_settings.custom.gauge_length"></dxi-item>
          <dxi-item dataField="level_calibration_settings.custom.min_adc"></dxi-item>
          <dxi-item dataField="level_calibration_settings.custom.max_adc"></dxi-item>
          <dxi-item dataField="level_calibration_settings.custom.offset"></dxi-item>
          <dxi-item dataField="level_calibration_settings.calibration"></dxi-item>
          <dxi-item dataField="test_value"></dxi-item>
          <!--<dxi-item>
            <dxo-label text="Valeur de test"></dxo-label>
            <div *dxTemplate>
              <dx-number-box
                [value]="0"
                format="#0.### V">
                <dxi-button name="test" location="after" [options]="testButton"></dxi-button>
              </dx-number-box>
            </div>
          </dxi-item>-->
        </dxi-item>
      </dxo-form>
    </dxo-editing>

    <dxo-column-chooser [enabled]="true" mode="select"></dxo-column-chooser>

    <dxo-group-panel [visible]="false"></dxo-group-panel>

    <dxo-export [enabled]="true" fileName="liste-citernes"
                [allowExportSelectedData]="true"></dxo-export>

    <dxo-sorting mode="multiple"></dxo-sorting>

    <dxo-selection
      selectAllMode="page"
      mode="multiple"
    ></dxo-selection>

    <dxo-paging [pageSize]="25"></dxo-paging>
    <dxo-pager
      [showPageSizeSelector]="true"
      [allowedPageSizes]="[25, 50, 100]"
      [showInfo]="true">
    </dxo-pager>
    <dxo-filter-row
      [visible]="true"></dxo-filter-row>
    <dxo-search-panel
      [visible]="true"
      [width]="240"></dxo-search-panel>
    <dxo-header-filter
      [visible]="true"></dxo-header-filter>
  </dx-data-grid>
</app-tab>

<app-sensor-history-popup #sensorHistory title="Historique Niveau">
  <ng-template let-sensor let-request="request" let-toolbar="toolbar">
    <app-sensor-history-chart [sensor]="sensor" [request]="request" [toolbar]="toolbar"></app-sensor-history-chart>
  </ng-template>
</app-sensor-history-popup>

<app-sensor-history-popup #sensorChanges title="Rapport de Remplissages">
  <ng-template let-sensor let-request="request" let-toolbar="toolbar">
    <app-sensor-history-changes [sensor]="sensor" [request]="request" [toolbar]="toolbar"></app-sensor-history-changes>
  </ng-template>
</app-sensor-history-popup>
